import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export const Dots = props => {
  const {colors, max} = props;

  if (colors.length && max > 0) {
    return (
      <div className="ndx-dots-wrapper">
        {colors.slice(0, max).map(color => {
          return (
            <div
              key={color.cssString}
              className="ndx-dot"
              style={{backgroundColor: color.cssString}}
            />
          );
        })}
      </div>
    );
  } else {
    return null;
  }
};

Dots.displayName = 'Ndx-Dots';
const propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      cssString: PropTypes.string.isRequired
    })
  ),
  max: PropTypes.number
};

Dots.propTypes = propTypes;
Dots.defaultProps = {
  max: 4
};
